module.exports = "module.exports = __webpack_public_path__ + &quot;./resources/no-jobs-found.svg&quot;;"